import {push} from "connected-react-router";
import {store} from "./configureStore";

export const navigateTo = (path: string): void => {
    store.dispatch(push(path));
};
